import gql from 'graphql-tag';

export const getFeedbackListQuery = gql`
query allFeedbacks($page: Int, $perPage: Int, $sortField: String, $sortOrder: String, $filter: FeedbackFilter) {
  items: allFeedbacks(
    page: $page
    perPage: $perPage
    sortField: $sortField
    sortOrder: $sortOrder
    filter: $filter
  ) {
    id
    sleuthName
    event {
      id
      eventLocation {
        id
        name
      }
      eventDirector {
        id
        firstName
        lastName
        email
        role
        name
      }
      name
      __typename
    }
    starNumbers
    feedbackContents
    createdAt
    updatedAt
    __typename
  }
  total: _allFeedbacksMeta(page: $page, perPage: $perPage, filter: $filter) {
    count
    __typename
  }
}
`;